import type { AxiosCollection, AxiosItem } from '@/types/Components/Response'
import type { AddressBook, AddressBookFormData } from '@/types/Models/AddressBook'
import { defineStore } from 'pinia'
import { none } from '@/services/Helpers'
import AddressBookProxy from '@/proxies/AddressBookProxy'
interface AddressBookFilter {
  page?: string
  limit?: string
  search?: string
  orderBy?: string
  ascending?: string
  company_id?: string
  type?: string
}

interface AddressBookStoreState {
  items: AddressBook[]
  loading: boolean
  count: number
  filter: AddressBookFilter
}

export const useAddressBookStore = defineStore('addressBook', {
  state: (): AddressBookStoreState => ({
    items: [],
    loading: false,
    count: 0,
    filter: {},
  }),

  actions: {
    fetchAll(params: AddressBookFilter = {}) {
      this.loading = true
      return new AddressBookProxy(params)
        .all()
        .then((response: AxiosCollection<AddressBook>) => {
          this.items = response.data
          this.count = response.count
          return response
        })
        .catch(none)
        .finally(() => {
          this.loading = false
        })
    },

    create(data: AddressBookFormData) {
      return new AddressBookProxy().create(data)
    },

    createSingle(data: AddressBookFormData): Promise<'created' | 'duplicate'> {
      return new AddressBookProxy().createSingle(data).then((response) => (response.status === 201 ? 'created' : 'duplicate'))
    },

    update(id: string, data: AddressBookFormData) {
      return new AddressBookProxy().update(id, data)
    },

    destroy(id: string) {
      return new AddressBookProxy().destroy(id)
    },

    find(id: string) {
      return new AddressBookProxy()
        .find(id)
        .then((response: AxiosItem<AddressBook>) => response.data)
        .catch(none)
    },
  },
})

export type AddressBookStore = ReturnType<typeof useAddressBookStore>
